import { lazy } from "react";
import ErrorPage from "./Error";
import HealthPage from "./HeathPage";
import CollectionScreen from "./screens/CollectionScreen";
import DesignRequisitionForm from "./screens/design-requisition"
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen";
import LoginRegisterScreen from "./screens/LoginRegisterScreen";
import ProfilePage from "./screens/ProfilePage";
import ResetPasswordScreen from "./screens/ResetPasswordScreen";

const LazySEOManagementScreen = lazy(() =>
  import("./collections/seo-management")
);

const LazyBatchAuditPortalScreen = lazy(() =>
  import("./collections/batch-audit")
);

const LazyDesignScreen = lazy(() => import("./collections/design-portal"));

const LazyErrorReportingPortalScreen = lazy(() =>
  import("./collections/error-reporting-portal")
);

const LazyK8Screen = lazy(() => import("./collections/k-8"));

const LazySTEScreen = lazy(() => import("./collections/ste"));
/* IMP: Add <Outlet /> (react-router-dom) component inside the parent component to render nested route components  */
const routes = [
  {
    path: "/",
    component: LoginRegisterScreen,
  },
  {
    path: "profile",
    component: ProfilePage,
    auth: true,
  },
  {
    path: "forgot-password",
    component: ForgotPasswordScreen,
  },
  {
    path: "reset-password",
    component: ResetPasswordScreen,
  },
  { path: "collections", component: CollectionScreen },
  { path: "collections/design-requisition-form", component: DesignRequisitionForm, auth: true },
  { path: "/k8/*", component: LazyK8Screen, auth: true },
  {
    path: "/seo/*",
    component: LazySEOManagementScreen,
    auth: true,
  },
  {
    path: "/uudesr/design-requisition/*",
    component: LazyDesignScreen,
    auth: true,
  },
  {
    path: "/erp/*",
    component: LazyErrorReportingPortalScreen,
    auth: true,
  },

  { path: "/tev/*", component: LazySTEScreen, auth: true },
  { path: "/bau/*", component: LazyBatchAuditPortalScreen, auth: true },
  //Fallback route
  { path: "*", component: ErrorPage },
  //Testing route
  { path: "/health", component: HealthPage },
];

export default routes;
